import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-04d67485")

_pushScopeId("data-v-04d67485")
const _hoisted_1 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MarkdownDisplay = _resolveComponent("MarkdownDisplay")!

  return (_openBlock(), _createBlock("footer", _hoisted_1, [
    _createVNode(_component_MarkdownDisplay, {
      markdown: _ctx.markdown,
      key: _ctx.markdown
    }, null, 8, ["markdown"])
  ]))
})